"use strict";

var _classCallCheck = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var prosemirror_commands_1 = require("prosemirror-commands");

var Extension_1 = __importDefault(require("../lib/Extension"));

var Mark = /*#__PURE__*/function (_Extension_1$default) {
  _inherits(Mark, _Extension_1$default);

  var _super = _createSuper(Mark);

  function Mark() {
    _classCallCheck(this, Mark);

    return _super.apply(this, arguments);
  }

  _createClass(Mark, [{
    key: "parseMarkdown",
    value: function parseMarkdown() {
      return {};
    }
  }, {
    key: "commands",
    value: function commands(_ref) {
      var type = _ref.type;
      return function () {
        return prosemirror_commands_1.toggleMark(type);
      };
    }
  }, {
    key: "type",
    get: function get() {
      return "mark";
    }
  }, {
    key: "markdownToken",
    get: function get() {
      return "";
    }
  }, {
    key: "toMarkdown",
    get: function get() {
      return {};
    }
  }]);

  return Mark;
}(Extension_1.default);

exports.default = Mark;